import axios from "axios";
import { useErrors, useSession } from "@/composables";
import { useCookies } from "@vueuse/integrations/useCookies";
import { ElNotification } from "element-plus";

const useAxios = (path = "") => {
  const cookies = useCookies();

  const { unauthorized } = useErrors();
  const jwt = cookies.get("session-lipmance");
  const session = useSession();

  const axiosClient = axios.create({
    baseURL: import.meta.env.VITE_BASE_URL + path,
    headers: {
      Authorization: `Bearer ${jwt}`,
    },
  });

  axiosClient.interceptors.request.use((req) => {
    const jwt = cookies.get("session-lipmance");

    if (jwt) {
      req.headers.Authorization = `Bearer ${jwt}`;
    }

    if (req.data) {
      const method = req.method?.toLowerCase();

      if (method === "post") {
        req.data.created_by = session.value?.id;
      }

      if (method === "put" || method === "patch") {
        req.data.created_by = session.value?.id;
        req.data.updated_by = session.value?.id;
      }
    }

    return req;
  });

  axiosClient.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      console.log(error);
      const res = error.response;
      const { url } = error.config;

      if (res.status == 401 && "/auth/login" != url) {
        unauthorized();
      } else if (res.status == 400) {
        ElNotification.error({
          title: res.data.message,
          message: "Harap isi semua input",
        });
      } else if (res.status >= 500) {
        ElNotification.error({
          title: res.data.message,
          message: "Terjadi kesalahan di server",
        });
      }

      console.error("Looks like there was a problem. Status Code: " + res.status);

      return Promise.reject(error);
    },
  );

  return axiosClient;
};

export default useAxios;
